import ExperienceCard from "./ExperienceCard";
import Container from "react-bootstrap/Container";
import experiences from "../data/experiences.json";

function ExperienceSection() {
  return (
    <Container>
      <section className="pt-5" id="experience">
        <h2 className="mb-4 border-bottom">Experience</h2>

        <div className="d-flex flex-wrap gap-lg-3 gap-4">
          {
            Object.values(experiences).map((experience, index) =>
              <ExperienceCard key={index} experience={experience} />
            )
          }
        </div>
      </section>
    </Container>
  );
}

export default ExperienceSection;